import {
  isValidCartStoreId,
  useSelectedStore,
} from "@src/store/reducers/CartSlice/selectors";
import { ProductItem } from "@src/hooks/query/useAllProduct";
import { useCallback, useSyncExternalStore } from "react";
import { ProductApiData } from "@src/interface/Product";
import useCartModelChange from "@src/backbone/hooks/useCartModelChange";
import {
  bindCartStoreContext,
  getStoreContextVersion,
  getStoreContextVersionServer,
  hydrateStoreContextFromWindowPrefetch,
  isStoreContextSynced,
  subscribeStoreContext,
} from "./storeContext";

const useShowProductPrice = () => {
  const store = useSelectedStore();
  const [, cart] = useCartModelChange("change");

  bindCartStoreContext(cart);
  hydrateStoreContextFromWindowPrefetch();
  useSyncExternalStore(
    subscribeStoreContext,
    getStoreContextVersion,
    getStoreContextVersionServer
  );

  const hasDeliveryAddress = !!cart.getAddressDelivery();
  // Deep-link ?id_store= : prioritaire sur le panier (sinon gate bloqué ~5s).
  let idStore = cart.get("id_store");
  if (typeof window !== "undefined") {
    try {
      const fromUrl = new URLSearchParams(window.location.search).get(
        "id_store"
      );
      if (isValidCartStoreId(fromUrl)) idStore = fromUrl;
    } catch {
      /* ignore */
    }
    const prefId = window.__RS_STORECONTEXT_PREFETCH__?.id_store;
    if (!isValidCartStoreId(idStore) && isValidCartStoreId(prefId)) {
      idStore = prefId;
    }
  }
  const hasValidStoreId = isValidCartStoreId(idStore);
  const backboneStore = cart.getStore();
  const hasStore = hasValidStoreId && !!(store ?? backboneStore);
  const hasLocation = hasDeliveryAddress || hasStore;
  // Flag module (onSync) OU modèle Backbone — évite le cas getStore() null / instance mismatch.
  const liveStoreContextReady =
    isStoreContextSynced(idStore) || !!backboneStore?.hasStoreContext();
  const storeContextReady = liveStoreContextReady;

  // Magasin sélectionné → attendre storecontext (évite le prix catalogue).
  const canShow = hasValidStoreId ? storeContextReady : hasLocation;

  const canShowProductPrice = useCallback(
    (_product?: ProductApiData | ProductItem): boolean => canShow,
    [canShow]
  );

  return {
    canShowProductPrice,
    hasStore,
    store,
    hasDeliveryAddress,
    hasLocation,
    storeContextReady,
  };
};

export default useShowProductPrice;
